import { ITableQueryData } from "types/frontend_models/table/ITableQueryData";
import { defaultDataTablePageSize } from "functions/tables/TableFunctions";
import { ITableFilter, FilterOperators } from "types/frontend_models/filtering/filters";
import { filterOperatorToSieveOperator } from "functions/converters/FilterOperatorConverters";
import { parseDateRangeString } from "functions/parsers/DateRangeParsers";
import { formatDateToQueryDate } from "functions/formatters/date";
import { isNullOrEmpty } from "functions/extensions/StringExtensions";


/** Builds a string query based on the passed table query data */
export function builBackendTableQuery(queryData: ITableQueryData): string
{
	let query = '?';
	
	if (queryData.currentPage) {
		query += 'page=' + queryData.currentPage.toString();
	} else {
		query += 'page=1';
	}

	if (queryData.pageSize) {
		query += '&pagesize=' + queryData.pageSize.toString();
	} else {
		query += '&pagesize=' + defaultDataTablePageSize.toString();
	}

	if (queryData.filters) {
		query += '&filters=';
		const lastIndex = queryData.filters.length - 1;
		queryData.filters.forEach((filter, index) =>
		{
			query += buildFilterQueryString(filter);
			if (index !== lastIndex) query += ',';
		});
	}

	if (queryData.sorted) {
		query += '&sorts=' + queryData.sorted;
	}

	// console.log({queryData, query})

	return query;
}

function buildFilterQueryString(filter: ITableFilter): string
{
	switch (filter.operator) {
		case FilterOperators.dateRange: {
			return buildDateRangeFilterQueryString(filter);
		}
		default: {
			// Default returns a string in format "key=value"
			return filter.key + filterOperatorToSieveOperator(filter.operator) + filter.value;
		}
	}
}

function buildDateRangeFilterQueryString(filter: ITableFilter): string
{
	/** Example:
	 *  Before = "2018-01-01-to-2019-01-01"
	 * 	After = "[key]>2018-01-01,[key]<2019-01-01"
	 */

	let query = '';
	let dateRange = parseDateRangeString(filter.value);
	if (dateRange.startDate) {
		query += filter.key;
		query += filterOperatorToSieveOperator(FilterOperators.greatherThan);
		query += formatDateToQueryDate(dateRange.startDate);
	}
	if (dateRange.endDate) {
		if (!isNullOrEmpty(query)) query += ',';
		query += filter.key;
		query += filterOperatorToSieveOperator(FilterOperators.lessThan);
		query += formatDateToQueryDate(dateRange.endDate);
	}
	return query;
}